import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Grid } from '@chakra-ui/react';
import { Input } from '../../inputs';
import { JsFieldName, JsFieldInspector } from '../../jsFormBase';
import { JsFormConfigContext } from '../../../contexts';
import * as example from './InputJsField.example';
/**
 * Component renders "/schemas/jsf-input" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is string or null.
 */
const InputJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['string', 'null'], examples: [{ uiSchema: example.UI_SCHEMA, schema: example.SCHEMA, data: example.FORM_DATA }], children: _jsxs(Grid, { "data-testid": "InputJsField-test", "data-name": props.name, gridTemplateColumns: "minmax(0, 180px) 1fr", alignItems: "center", gap: "4px", children: [_jsx(JsFieldName, { name: props.schema.title }), _jsx(Input, { size: "xs", variant: "outline", isOnChangeOnlyOnBlur: true, value: props.formData, disabled: props.schema.readOnly, rightElement: props.schema.$comment ? _jsx(_Fragment, { children: props.schema.$comment }) : undefined, onChange: (value) => props.onChange(value) })] }) }));
};
export const InputJsField = InputJsFieldFC;
//# sourceMappingURL=InputJsField.js.map